import React from "react"
import { Input } from "./Input"
import { clsx } from "clsx"

export const PVSNumberInput = ({
  value,
  onChange,
  placeholder,
  disabled,
  className,
}) => {
  const handleChange = e => {
    const inputValue = e.target.value
    onChange(inputValue)
  }

  return (
    <div className="mobile-input-container">
      <Input
        type="text"
        value={value}
        onChange={handleChange}
        placeholder={placeholder || "Enter Number Here"}
        disabled={disabled}
        className={clsx(className, "mobile-input")}
        aria-label="Mobile number"
        // maxLength={10}
      />
    </div>
  )
}
